import '@/prototypes/array';


export default {

    name: 'ticket',
    namespaced: true,

    state: {       
        ticket: null
    },

    getters: { 
        ticket(state){
            return state.ticket;
        }
    },

    mutations: {
        TICKET(state, ticket) {
            state.ticket = ticket;
            if (!state.ticket) return;
        },

        RESET_STATE(state){
            state.ticket = null;
        }
    },

    actions: {         
        getTicket({commit}, ticket){
            commit('TICKET', ticket);
        },
        resetState({commit}){
            commit('RESET_STATE');
        }
    }  
};